import { render, staticRenderFns } from "./subproperty-view-page.vue?vue&type=template&id=1f25fb87&"
import script from "./subproperty-view-page.vue?vue&type=script&lang=js&"
export * from "./subproperty-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports